import React, { Component } from 'react';
import { FavoriteChangeConsumer } from '@atlassian/jira-favourite-change-provider/src/view/FavoriteChangeConsumer.tsx';
import { getFavorite } from './rest/get-favorite.tsx';
import { FavoriteButton, type OwnProps } from './view/view.tsx';

// eslint-disable-next-line jira/react/no-class-components
export default class FavoriteButtonWrapper extends Component<OwnProps> {
	render() {
		return (
			<FavoriteChangeConsumer>
				{(favoriteChangeContext) => (
					<FavoriteButton {...this.props} favoriteChangeContext={favoriteChangeContext} />
				)}
			</FavoriteChangeConsumer>
		);
	}
}

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { getFavorite };
